<script setup lang="ts">
withDefaults(defineProps<{
  ariaLabel?: string
  iconLeft?: string
  iconRight?: string
  square?: boolean
  to?: string
  type?: 'button' | 'submit'
}>(), {
  ariaLabel: undefined,
  iconLeft: undefined,
  iconRight: undefined,
  square: false,
  to: undefined,
  type: 'button',
})

const baseClasses = [
  'inline-flex items-center justify-center rounded-pill border-[1.5px]',
  'border-brand-ink/20 bg-default text-default',
  'font-display uppercase text-[12px] tracking-[0.14em]',
  'shadow-sm transition-colors',
  'hover:bg-elevated hover:border-brand-ink',
  'focus-visible:outline-2 focus-visible:outline-brand-ink focus-visible:outline-offset-2',
]
</script>

<template>
  <NuxtLink
    v-if="to"
    :to="to"
    :aria-label="ariaLabel"
    :class="[...baseClasses, square ? 'size-9' : 'gap-2 px-4 py-2']"
  >
    <UIcon
      v-if="iconLeft"
      :name="iconLeft"
      class="size-4"
    />
    <slot/>
    <UIcon
      v-if="iconRight"
      :name="iconRight"
      class="size-4"
    />
  </NuxtLink>
  <button
    v-else
    :type="type"
    :aria-label="ariaLabel"
    :class="[...baseClasses, square ? 'size-9' : 'gap-2 px-4 py-2']"
  >
    <UIcon
      v-if="iconLeft"
      :name="iconLeft"
      class="size-4"
    />
    <slot/>
    <UIcon
      v-if="iconRight"
      :name="iconRight"
      class="size-4"
    />
  </button>
</template>
